import '../scss/style.scss';
import '../images/logo_digital360.svg';
import '../images/logo_telepass.svg';
import '../images/ic_menu_white.svg';
import '../images/service_card_placeholder.png';
import '../images/Certificato_icon.svg';
import '../images/sostenibilita.png';
import '../images/sostenibilita_icon.svg';
import '../images/intestazione_city_cropped.png';
import '../images/City_skyline.svg';
import '../images/ic_location.svg';
import '../images/Logo_placeholder.png';
import '../images/RaccoltaDati.svg';
import '../images/CondivisioneDati.svg';
import '../images/favicon.png';

import Drawer from './frontend/drawer';

document.addEventListener('DOMContentLoaded', () => {
	const obj = new Drawer();
	obj.init();
});
